import {EN} from './en'
import {ZhTW} from './zhTW'
import {ZhCN} from './zhCN'

export const MessCode = {
    en:EN.en,
    zhTW:ZhTW.zhTW,
    zhCN:ZhCN.zhCN
}